import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import { ConfigurationType } from "@insite/client-framework/Services/ProductServiceV2";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductAvailabilityStyles } from "@insite/content-library/Components/ProductAvailability";
import ProductContextAvailability from "@insite/content-library/Components/ProductContextAvailability";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState) => ({
    configurationCompleted: state.pages.productDetails.configurationCompleted,
    currentLanguage: state.context.session.language,
    currentWebsiteName: state.context.website.name,
});

export interface ProductDetailsAvailabilityStyles {
    availability?: ProductAvailabilityStyles;
    nonPurshsedStyles?: InjectableCss;
    lowStockStyles?: InjectableCss;
}

export const availabilityStyles: ProductDetailsAvailabilityStyles = {
    availability: {
        container: {
            css: css`
                padding: 0px 20px;
            `,
        },
    },
    nonPurshsedStyles: {
        css: css`
            padding: 0px 20px;
            margin: 13px 0px;
            span {
                font-size: 16px;
                font-weight: 600;
            }
        `,
    },
    lowStockStyles: {
        css: css`
            padding: 0px 20px;
            padding-top: 8px;
            span {
                font-size: 16px;
                font-weight: 500;
                color: rgb(230, 78, 37);
            }
        `,
    },
};

const styles = availabilityStyles;

const ProductDetailsAvailability = ({
    productInfo,
    product,
    configurationCompleted,
    currentLanguage,
    currentWebsiteName,
}: Props) => {
    if (!product) {
        return null;
    }
    const discontinuedProduct = product.properties?.isObsolete?.toLowerCase() === "true";

    let lowStockInventory;

    if (
        productInfo.inventory?.qtyOnHand &&
        productInfo.inventory.qtyOnHand > 0 &&
        productInfo.inventory?.qtyOnHand < productInfo.qtyOrdered
    ) {
        lowStockInventory = true;
    }
    return (
        <>
            {currentLanguage?.languageCode.toLowerCase() === "en" && !product.cantBuy && !discontinuedProduct && (
                <ProductContextAvailability
                    isProductDetailsPage={true}
                    configurationCompleted={configurationCompleted}
                    extendedStyles={styles.availability}
                />
            )}
            {currentLanguage?.languageCode.toLowerCase() === "en" && !product.cantBuy && lowStockInventory && (
                <StyledWrapper {...styles.lowStockStyles}>
                    <Typography>{siteMessage("Low_Stock_Message")}</Typography>
                </StyledWrapper>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProduct(ProductDetailsAvailability)),
    definition: {
        displayName: "Availability",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
